export const validateField = (field, value, isJuridica) => {
  switch (field) {
    case "ruc":
      if (!value || !value.toString().trim()) {
        return "El RUC es requerido";
      } else if (!/^\d{13}$/.test(value)) {
        return "El RUC debe contener 13 dígitos";
      }
      return "";

    case "razon_social":
      if (!value || !value.toString().trim()) {
        return isJuridica
          ? "La Razón Social es requerida"
          : "Los Nombres Completos son requeridos";
      } else if (value.length > 255) {
        return "No pueden exceder 255 caracteres";
      }
      return "";

    case "razon_comercial":
      if (value && value.length > 255) {
        return "No pueden exceder 255 caracteres";
      }
      return "";

    case "direccion_establecimiento":
      if (!value || !value.toString().trim()) {
        return "La dirección es requerida";
      } else if (value.length > 500) {
        return "No puede exceder 500 caracteres";
      }
      return "";

    case "provincia":
      if (!value || !value.toString().trim()) {
        return "La provincia es requerida";
      } else if (value.length > 100) {
        return "No puede exceder 100 caracteres";
      }
      return "";

    case "canton":
      if (!value || !value.toString().trim()) {
        return "El cantón es requerido";
      } else if (value.length > 100) {
        return "No puede exceder 100 caracteres";
      }
      return "";

    case "servicios_prestados":
      if (!value || !value.toString().trim()) {
        return "Los servicios prestados son requeridos";
      }
      return "";

    case "telefono1":
      if (!value || !value.toString().trim()) {
        return "El teléfono es requerido";
      } else if (!/^\d{7,15}$/.test(value)) {
        return "Debe contener solo números (7-15 dígitos)";
      }
      return "";

    case "telefono2":
      if (value && !/^\d{7,15}$/.test(value)) {
        return "Debe contener solo números (7-15 dígitos)";
      }
      return "";

    case "telefono3":
      if (value && !/^\d{7,15}$/.test(value)) {
        return "Debe contener solo números (7-15 dígitos)";
      }
      return "";

    case "persona_contacto":
      if (!value || !value.toString().trim()) {
        return "La persona de contacto es requerida";
      } else if (value.length > 100) {
        return "No puede exceder 100 caracteres";
      }
      return "";

    case "cargo":
      if (!value || !value.toString().trim()) {
        return "El cargo es requerido";
      } else if (value.length > 100) {
        return "No puede exceder 100 caracteres";
      }
      return "";

    case "email_contacto":
      const mailRE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!value || !value.toString().trim()) {
        return "El email es requerido";
      } else if (!mailRE.test(value)) {
        return "Ingrese un email válido";
      } else if (value.length > 100) {
        return "No puede exceder 100 caracteres";
      }
      return "";

    case "email_transferencia":
      const mailRETransf = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!value || !value.toString().trim()) {
        return "El email es requerido";
      } else if (!mailRETransf.test(value)) {
        return "Ingrese un email válido";
      } else if (value.length > 100) {
        return "No puede exceder 100 caracteres";
      }
      return "";

    case "cedula_representante":
      if (isJuridica && (!value || !value.toString().trim())) {
        return "La cédula del representante es requerida";
      } else if (value && !/^\d{10}$/.test(value)) {
        return "La cédula debe contener 10 dígitos";
      }
      return "";

    case "email_retencion":
      const mailRERet = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!value || !value.toString().trim()) {
        return "El email es requerido";
      } else if (!mailRERet.test(value)) {
        return "Ingrese un email válido";
      } else if (value.length > 100) {
        return "No puede exceder 100 caracteres";
      }
      return "";

    case "forma_pago_otro":
      if (value && value.length > 100) {
        return "No puede exceder 100 caracteres";
      }
      return "";

    case "tipo_cuenta":
      if (!value || !value.toString().trim()) {
        return "El tipo de cuenta es requerido";
      }
      return "";

    case "numero_cuenta":
      if (!value || !value.toString().trim()) {
        return "El número de cuenta es requerido";
      } else if (!/^\d{10,20}$/.test(value)) {
        return "El número de cuenta debe contener solo números (10-20 dígitos)";
      } else if (value.length > 50) {
        return "No puede exceder 50 caracteres";
      }
      return "";

    case "nombre_banco":
      if (!value || !value.toString().trim()) {
        return "El nombre del banco es requerido";
      } else if (value.length > 100) {
        return "No puede exceder 100 caracteres";
      }
      return "";

    case "representante_legal":
      if (isJuridica && (!value || !value.toString().trim())) {
        return "El representante legal es requerido";
      } else if (value && value.length > 100) {
        return "No puede exceder 100 caracteres";
      }
      return "";

    case "contribuyente_especial":
      if (value === null || value === undefined || value === "") {
        return "Debe seleccionar si es contribuyente especial";
      }
      return "";

    case "regimen_rimpe":
      if (!value || !value.toString().trim()) {
        return "Debe seleccionar un régimen RIMPE";
      }
      return "";

    default:
      return "";
  }
};

export const getEmptyDataStructure = () => ({
  ruc: "",
  razon_social: "",
  razon_comercial: "",
  direccion_establecimiento: "",
  provincia: "",
  canton: "",
  servicios_prestados: "",
  telefono1: "",
  telefono2: "",
  telefono3: "",
  persona_contacto: "",
  cargo: "",
  email_contacto: "",
  forma_pago: "",
  forma_pago_otro: "",
  email_transferencia: "",
  tipo_cuenta: "",
  numero_cuenta: "",
  nombre_banco: "",
  email_retencion: "",
  contribuyente_especial: null,
  regimen_rimpe: "",
  representante_legal: "",
  cedula_representante: "",
});